<div 
  [gaCategory]="eventCategory"
  class="pillbox"
  [ngClass]="{
    'pillbox--padding-dense': padding === 'dense',
    'pillbox--padding-none': padding === 'none',
    'pillbox--vertical': orientation === 'vertical'
  }">
  <ng-content></ng-content>
  
  <ng-container *ngIf="canExit">
    <app-pillbox-divider></app-pillbox-divider>

    <button 
      gaEvent
      [gaAction]="'Clicked Close ' + name"
      data-test="closePillboxButton"
      app-pin-button
      buttonType="ghost"
      (click)="handleExitClick()"
      [attr.aria-label]="'Close ' + name"
      [matTooltip]="'Close ' + name"
      icon="times">
    </button>
  </ng-container>
</div>